import React from "react";
import AppNavigator from "./services/context";

const App = () => {
  return <AppNavigator />;
};

export default App;
